import Header from './components/Header';
import HeroSection from './components/HeroSection';
import SectionFAQ from './components/SectionFAQ';
import SectionContact from './components/SectionContact';
import SectionApp from './components/SectionApp';
import SectionCarousel from './components/SectionCarousel';
import SectionTopics from './components/SectionTopics';
import SectionCards from './components/SectionCards';
import SectionRanking from './components/SectionRanking';
import SectionComments from './components/SectionComments';
import SectionMedia from './components/SectionMedia';
import SectionUpdates from './components/SectionUpdates';
import SectionIndex from './components/SectionIndex';
import SectionAbout from './components/SectionAbout';
import SectionFeatures from './components/SectionFeatures';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <SectionFAQ />
        <SectionContact />
        <SectionApp />
        <SectionCarousel />
        <SectionTopics />
        <SectionCards />
        <SectionRanking />
        <SectionComments />
        <SectionMedia />
        <SectionUpdates />
        <SectionIndex />
        <SectionAbout />
        <SectionFeatures />
      </main>
      <Footer />
    </>
  );
}